module.exports = __webpack_public_path__ + "static/media/cover-product-1.5f78b1d6.jpg";